import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiService from "../services/apiService";

const ViewContent = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [content, setcontent] = useState({
    description: "",
    title: "",
    duration: "",
    chapter_count: "",
    tags: "",
    rfid: "",
    is_kids_favourite: false,
    is_all_time_classic: false,
    // is_sleep: false,
    cover_image: "",
    chapters: [],
    characters: [],
  });

  useEffect(() => {
    fetchcontent();
  }, []);

  const fetchcontent = async () => {
    try {
      const response = await apiService.fetchData(`admin/content/${id}`);
      if (!response.error && response.data) {
        setcontent({
          description: response.data.description || "",
          title: response.data.title || "",
          img: response.data.img || "",
          duration: response.data.duration || "",
          chapter_count: response.data.chapter_count || "",
          tags: response.data.tags || "",
          rfid: response.data.rfid || "",
          is_kids_favourite: response.data.is_kids_favourite === 1,
          is_all_time_classic: response.data.is_all_time_classic === 1,
          // is_sleep: response.data.is_sleep === 1,
          cover_image: response.data?.ContentToBookDetails?.cover_image || "",
          chapters: response.data?.ContentToChapterDetails || [],
          characters: response.data?.ContentToCharacterDetails || [],
          content_type: response.data.content_type || "", 
        });
      }
    } catch (error) {
      console.error("Error fetching content:", error);
    }
  };

  const inputStyle = {
    backgroundColor: "#f5f5f5",
    border: "1px solid #ced4da",
    color: "#495057",
    cursor: "not-allowed",
  };

  const labelStyle = {
    fontWeight: "600",
  };

  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h4>View Content</h4>
          </div>
          <div className="card-body">
            <form>
            {content.img && (
                <>
                  <hr />
                  <h5 className="mt-4 mb-3" style={{ fontWeight: "600" }}>
                    Content Image
                  </h5>
                  <div className="form-group mb-3">
                    <div>
                      <img
                        src={apiService.getFullImageUrl(content.img)}
                        alt="Book Cover"
                        style={{
                          maxHeight: "200px",
                          objectFit: "contain",
                          borderRadius: "8px",
                          marginTop: "10px",
                          border: "1px solid #ccc",
                          padding: "5px",
                          backgroundColor: "#fff",
                        }}
                      />
                    </div>
                  </div>
                </>
              )}

              {content.title && (
                <div className="form-group mb-3">
                  <label style={labelStyle}>Title</label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    value={content.title}
                    disabled
                    style={inputStyle}
                  />
                </div>
              )}

              {content.description && (
                <div className="form-group mb-3">
                  <label style={labelStyle}>Description</label>
                  <textarea
                    name="description"
                    className="form-control"
                    value={content.description}
                    disabled
                    rows="3"
                    style={inputStyle}
                  ></textarea>
                </div>
              )}

              {content.duration && (
                <div className="form-group mb-3">
                  <label style={labelStyle}>Duration</label>
                  <input
                    type="text"
                    name="duration"
                    className="form-control"
                    value={content.duration}
                    disabled
                    style={inputStyle}
                  />
                </div>
              )}
{content.content_type && (
  <div className="form-group mb-3">
    <label style={labelStyle}>Content Type</label>
    <input
      type="text"
      name="content_type"
      className="form-control"
      value={
        content.content_type === 1
          ? "Story"
          : content.content_type === 2
          ? "Learning"
          : "Song"
      }
      disabled
      style={inputStyle}
    />
  </div>
)}
              {content.chapter_count && (
                <div className="form-group mb-3">
                  <label style={labelStyle}>Chapter Count</label>
                  <input
                    type="number"
                    name="chapter_count"
                    className="form-control"
                    value={content.chapter_count}
                    disabled
                    style={inputStyle}
                  />
                </div>
              )}

              {content.tags && (
                <div className="form-group mb-3">
                  <label style={labelStyle}>Tags</label>
                  <input
                    type="text"
                    name="tags"
                    className="form-control"
                    value={content.tags}
                    disabled
                    style={inputStyle}
                  />
                </div>
              )}

              {content.rfid && (
                <div className="form-group mb-3">
                  <label style={labelStyle}>RFID</label>
                  <input
                    type="text"
                    name="rfid"
                    className="form-control"
                    value={content.rfid}
                    disabled
                    style={inputStyle}
                  />
                </div>
              )}

              {content.is_kids_favourite && (
                <div className="form-group mb-2">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name="is_kids_favourite"
                      checked={content.is_kids_favourite}
                      disabled
                      className="form-check-input"
                    />
                    <label className="form-check-label" style={labelStyle}>
                      Is Kids Favourite
                    </label>
                  </div>
                </div>
              )}

              {content.is_all_time_classic && (
                <div className="form-group mb-2">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name="is_all_time_classic"
                      checked={content.is_all_time_classic}
                      disabled
                      className="form-check-input"
                    />
                    <label className="form-check-label" style={labelStyle}>
                      Is All Time Classic
                    </label>
                  </div>
                </div>
              )}

              {/* {content.is_sleep && (
                <div className="form-group mb-4">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      name="is_sleep"
                      checked={content.is_sleep}
                      disabled
                      className="form-check-input"
                    />
                    <label className="form-check-label" style={labelStyle}>
                      Is Sleep
                    </label>
                  </div>
                </div>
              )} */}

              {content.cover_image && (
                <>
                  <hr />
                  <h5 className="mt-4 mb-3" style={{ fontWeight: "600" }}>
                    Content Book Details
                  </h5>
                  <div className="form-group mb-3">
                    <label style={labelStyle}>Cover Image:</label>
                    <div>
                      <img
                        src={apiService.getFullImageUrl(content.cover_image)}
                        alt="Book Cover"
                        style={{
                          maxHeight: "200px",
                          objectFit: "contain",
                          borderRadius: "8px",
                          marginTop: "10px",
                          border: "1px solid #ccc",
                          padding: "5px",
                          backgroundColor: "#fff",
                        }}
                      />
                    </div>
                  </div>
                </>
              )}

              {content.chapters?.length > 0 && (
                <>
                  <hr />
                  <h5 className="mt-4 mb-3" style={{ fontWeight: "600" }}>
                    Content Chapter Details
                  </h5>
                  {content.chapters.map((chapter, index) => (
                    <div key={chapter.chapter_id} className="mb-3 p-3 border rounded bg-light">
                      <h6 style={{ fontWeight: "600" }}>
                        Chapter {index + 1}: {chapter.title}
                      </h6>
                      <p className="mb-1">
                        <strong>Description:</strong> {chapter.description}
                      </p>
                    </div>
                  ))}
                </>
              )}

              {content.characters?.length > 0 && (
                <>
                  <hr />
                  <h5 className="mt-4 mb-3" style={{ fontWeight: "600" }}>
                    Content Character Details
                  </h5>
                  {content.characters.map((character, index) => (
                    <div key={character.character_id} className="mb-3 p-3 border rounded bg-light">
                      <h6 style={{ fontWeight: "600" }}>
                        Character {index + 1}: {character.character_name}
                      </h6>
                      <p className="mb-1">
                        <strong>Description:</strong> {character.character_desc}
                      </p>

                      {character.character_img && (
                        <>
                          <label style={labelStyle}>Image:</label>
                          <div>
                            <img
                              src={apiService.getFullImageUrl(character.character_img)}
                              alt="Character Image"
                              style={{
                                maxHeight: "200px",
                                objectFit: "contain",
                                borderRadius: "8px",
                                marginTop: "10px",
                                border: "1px solid #ccc",
                                padding: "5px",
                                backgroundColor: "#fff",
                              }}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </>
              )}

              <div className="d-flex gap-2 mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/content")}
                >
                  Back to List
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewContent;
